import React, { FunctionComponent } from "react";
import { Box, Chip, Typography } from "@mui/material";
import { ChatSelectedDocument } from "../../context/ChatContext";
import { colorGrayLight } from "../../styles/theme";

interface DocumentSelectionFooterProps {
	selectedDocuments: ChatSelectedDocument[];
	onRemoveDocument: (documentId: number) => void;
}

const DocumentSelectionFooter: FunctionComponent<
	DocumentSelectionFooterProps
> = ({ selectedDocuments, onRemoveDocument }) => {
	return (
		<Box
			sx={{
				padding: "10px 16px",
				borderTop: `1px solid ${colorGrayLight}`,
				display: "flex",
				flexDirection: "column",
				gap: "6px",
			}}
		>
			<Typography variant="caption" sx={{ opacity: 0.7 }}>
				{selectedDocuments.length
					? `Asking about ${selectedDocuments.length} document${
							selectedDocuments.length > 1 ? "s" : ""
						}`
					: "Select documents with the ✓ on the cards to narrow the question"}
			</Typography>
			{Boolean(selectedDocuments.length) && (
				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						gap: "6px",
						maxHeight: "90px",
						overflowY: "auto",
					}}
				>
					{selectedDocuments.map((document) => (
						<Chip
							key={document.id}
							label={document.title}
							size="small"
							sx={{ maxWidth: "100%" }}
							onDelete={() => onRemoveDocument(document.id)}
						/>
					))}
				</Box>
			)}
		</Box>
	);
};

export default DocumentSelectionFooter;
